import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Typography,
} from "antd";

const { Text } = Typography;
const { TextArea } = Input;

const CompletionModal = ({
  open,
  point,
  loading = false,
  onCancel,
  onSubmit,
  showRecipientPhone = true,
  showPhoto = false,
  showSignature = false,
  showOTP = false,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleFinish = (values) => {
    onSubmit?.({
      ...values,
      route_point_id: point?.route_point_id,
    });
  };

  return (
    <Modal
      open={open}
      title="Complete Delivery"
      width={600}
      destroyOnClose
      centered
      confirmLoading={loading}
      okText="Complete Delivery"
      onCancel={onCancel}
      onOk={() => form.submit()}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Text type="secondary">
            Complete delivery for
          </Text>

          <br />

          <Text strong>
            {point?.name || "-"}
          </Text>

          <br />

          <Text type="secondary">
            {point?.address || "-"}
          </Text>
        </Col>

        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
          >
            <Form.Item
              label="Recipient Name"
              name="recipient_name"
              rules={[
                {
                  required: true,
                  message:
                    "Recipient name is required.",
                },
              ]}
            >
              <Input
                placeholder="Enter recipient name"
              />
            </Form.Item>

            {showRecipientPhone && (
            <Form.Item
                label="Recipient Phone"
                name="recipient_phone"
            >
                <Input placeholder="Enter recipient phone" />
            </Form.Item>
            )}

            <Form.Item
              label="Remarks"
              name="remarks"
            >
              <TextArea
                rows={4}
                placeholder="Remarks (optional)"
              />
            </Form.Item>

            {/* Future Enhancements */}

            {/*
            <Form.Item
                label="Delivery Photo"
                name="photo"
            >
                <Upload />
            </Form.Item>

            <Form.Item
                label="Customer Signature"
                name="signature"
            >
                <SignaturePad />
            </Form.Item>

            <Form.Item
                label="OTP"
                name="otp"
            >
                <Input />
            </Form.Item>
            */}
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};

export default CompletionModal;